export default "__VITE_ASSET__96a14416__"